import moment from "moment";

/**
 * @returns the UTC timestamp
 */
export const getCurrentTimestamp = () => {
  return Math.floor(Date.now() / 1000);
};

/**
 * @returns the fields for the timestamp of the record into database
 */
export const getTimestampFields = () => {
  const timestamp = getCurrentTimestamp();
  return {
    createdAt: timestamp,
    updatedAt: timestamp,
  };
};

export const checkHaveGivenDate = (dates: any, checkDate: any) => {
  const formatedDates = dates.map((d: any) => moment(d).format("yyyy-MM-DD"));
  return formatedDates.includes(moment(checkDate).format("yyyy-MM-DD"));
};

export const toMMSS = (val: any) => {
  var sec_num = parseInt(val, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes: any = Math.floor((sec_num - hours * 3600) / 60);
  var seconds: any = sec_num - hours * 3600 - minutes * 60;

  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    seconds = "0" + seconds;
  }
  return minutes + ":" + seconds;
};

export const convertoUserTimezone = (time: any, format: string) => {
  var timedifference = new Date().getTimezoneOffset();
  return moment(time).utcOffset(timedifference).format(format);
};

export const getUTCYMD = (d: any) => {
  const date = new Date(d);
  return `${(new Date(date).getUTCMonth() + 1).toString().padStart(2, "0")}
                    /${new Date(date).getUTCDate().toString().padStart(2, "0")}/
                    ${new Date(date).getUTCFullYear()}`;
};
